import { Button } from '@rocketmakers/armstrong';
import * as React from 'react';
import { useBee } from '../../../../../shared/hooks/useBee';
import { BackButton } from '../../../components/buttons/back-button';
import { DeviceSummary } from '../../../components/layout/deviceSummary/device-summary';
import { useRoutePaths } from '../../../../../shared/context/paths';
import { routePaths } from '../../../routes';
import { Spinner } from '../../../components/spinner/spinner';

function parseVersion(version: string) {
  return version.match(/v?(\d+\.\d+\.\d).*/)?.[1];
}

export const FirmwareCheckView: React.FunctionComponent = () => {
  const { replace } = useRoutePaths();
  const { beeInfo, findBee, loading } = useBee();

  const isLatestAppVersion = () => {
    if (!beeInfo) return false;

    const { currentAppVersion, latestAppVersion } = beeInfo;

    if (!currentAppVersion || !latestAppVersion) return false;

    const semverParts = 3;
    const currentVersionParts = parseVersion(currentAppVersion).split('.');
    const latestVersionParts = parseVersion(latestAppVersion).split('.');

    for (let i = 0; i < semverParts; i++) {
      const currentVersion = Number(currentVersionParts[i]);
      const latestVersion = Number(latestVersionParts[i]);

      if (Number.isNaN(currentAppVersion) || Number.isNaN(currentAppVersion)) return false;

      if (currentVersion > latestVersion) return true;

      if (latestVersion > currentVersion) return false;
    }

    return true;
  };

  const checkFirmware = async () => {
    if (isLatestAppVersion()) {
      replace(routePaths.verify.firmware.updated);
    }
  };

  React.useEffect(() => {
    checkFirmware();
  }, [beeInfo]);

  const handleRefresh = async () => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const { deviceId } = beeInfo?.bee;

    findBee({ deviceId });
  };

  return (
    <>
      <div>
        {loading && <Spinner />}
        <BackButton />
        <h1>
          Verify <span className="color-primary">BEE Requires Update</span>
        </h1>

        <div>
          <p>
            The firmware on the BEE does not support device verification checks. Please call Sero so the device can be
            updated: 0292 000 28 82.
          </p>
          <DeviceSummary
            fields={[
              { name: 'BEE ID', value: loading ? 'Loading...' : beeInfo?.bee?.deviceId },
              { name: 'MAC address', value: loading ? 'Loading...' : beeInfo?.bee?.routerId },
              { name: 'Firmware', value: loading ? 'Loading...' : beeInfo?.currentAppVersion },
            ]}
          />
        </div>

        <div className="row">
          <Button
            className="continue-button btn-full btn-large"
            onClick={() => handleRefresh()}
            data-qa="refresh-button"
          >
            Refresh
          </Button>
        </div>
      </div>
    </>
  );
};
